import type { CityConfig } from "../city-template/types";

export const windhamConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Maine CDC Vital Records", href: "https://www.maine.gov/dhhs/mecdc/public-health-systems/data-research/vital-records/", description: "Official Maine vital records office in Augusta" },
    { label: "Marriage Licenses — Cumberland County Clerk", href: "https://www.cumberlandcounty.org/", description: "Cumberland County Clerk — marriage license issuance" },
    { label: "Divorce Records — Cumberland County Clerk", href: "https://www.cumberlandcounty.org/", description: "Cumberland County Clerk — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Maine CDC for online vital record orders" },
  ],
  city: "Windham",
  state: "Maine",
  stateAbbr: "ME",
  slug: "windham",
  route: "/cities/windham",
  title: "Emergency Passport Windham, ME — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Windham, Maine — as fast as 24 hours. Fast passport renewal, same-day help, and child passport expediting for Windham, Westbrook, Gorham, Raymond, and Sebago Lakes area travelers. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Windham, ME",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Windham and Sebago Lakes area travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Windham%20Maine%20suburban%20lakes%20region%20with%20Sebago%20Lake%20in%20background%2C%20Maine%20Route%20302%20corridor%2C%20suburban%20homes%20with%20pine%20trees%2C%20New%20England%20rural-suburban%20mix%2C%20summer%20afternoon%20light%2C%20professional%20photography%2C%20no%20people%20or%20visible%20text%2C%20green%20landscape%20with%20lake%20shimmer%20in%20distance&width=1800&height=700&seq=windham-me-hero-001&orientation=landscape",
  heroImageAlt: "Windham Maine suburban lakes area with Sebago Lake in background",
  geoPosition: "43.7996;-70.4156",
  geoPlacename: "Windham, Maine",
  lastModified: "2026-06-01",
  regionalAgency: {
    name: "Boston Passport Agency",
    address: "5 Custom House St, Boston, MA 02110",
    distance: "Located in Boston — approximately 120 miles (2 hours) from Windham, ME",
  },
  nearbyCitiesZips: [
    { name: "Windham", zips: "04062" },
    { name: "Westbrook", zips: "04092" },
    { name: "Gorham", zips: "04038" },
    { name: "Raymond", zips: "04071" },
    { name: "Naples", zips: "04055" },
    { name: "Standish", zips: "04084" },
    { name: "Buxton", zips: "04093" },
    { name: "Hollis", zips: "04042" },
    { name: "Sebago", zips: "04029" },
    { name: "South Windham", zips: "04062" },
    { name: "North Windham", zips: "04062" },
    { name: "Little Sebago", zips: "04062" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Windham departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels to our processing center" },
  ],
  internalLinks: [
    { name: "Fast passport renewal in Westbrook", route: "/cities/westbrook" },
    { name: "Emergency passport help in Portland", route: "/cities/portland-me" },
    { name: "Urgent passport services in Gorham", route: "/cities/gorham" },
    { name: "Same-day passport help in Scarborough", route: "/cities/scarborough" },
    { name: "Expedited passport services in Brunswick", route: "/cities/brunswick" },
    { name: "Passport courier services in Yarmouth", route: "/cities/yarmouth" },
    { name: "Rush passport help in South Portland", route: "/cities/south-portland" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Windham, Maine remotely via secure courier. We do not have a walk-in office in Windham — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Windham travelers.",
  fpcOfficeAddress: "One Boston Place, #2600, Boston, MA 02108",
  fpcOfficeDistance: "Serving Sebago Lakes and the surrounding areas",
  serviceAreaIntro: "Fast Passport Center provides emergency and fast passport renewal services throughout Windham and the Sebago Lakes region. From North Windham shopping centers to the shores of Sebago Lake and Little Sebago — we help Windham travelers get their passports fast, often in 24–48 hours through our registered courier service.",
  nearbyCitiesIntro: "We serve all Windham neighborhoods and nearby towns including Westbrook, Gorham, Raymond, Naples, Standish, Buxton, Hollis, and Sebago. If you are in the Sebago Lakes area, we have you covered.",
  howItWorksIntro: "Most Windham travelers complete everything online and ship documents overnight. No need to drive to Boston or wait in line at the regional agency. Our emergency and expedited passport process is designed for Maine travelers who need fast, reliable results.",
  mistakesIntro: "Windham is a growing suburban community near the Sebago Lakes, but passport acceptance facilities still have strict requirements. Here are the most common mistakes we see from Windham-area travelers.",
  testimonialsIntro: "Windham travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Windham? Here are the most common ones we hear from Sebago Lakes travelers.",
  statePageRoute: "/states/maine",
  statePageName: "Maine",
  dmvWebsite: "https://www.maine.gov/sos/bmv",
  dmvLabel: "Maine BMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns and budget fights",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Windham international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Lisa M.",
      location: "Windham, ME",
      rating: 5,
      text: "We had a family emergency overseas and needed passports fast. Fast Passport Center got all four of us processed in under 3 days. Shipping from North Windham was easy with the prepaid label they provided.",
      service: "Emergency Passport",
    },
    {
      name: "David H.",
      location: "Raymond, ME",
      rating: 5,
      text: "My renewal was stuck at the post office for weeks. I switched to Fast Passport Center and had my new passport in 4 days. The difference is night and day. Worth every penny for Sebago Lake travelers.",
      service: "Passport Renewal",
    },
    {
      name: "Michelle C.",
      location: "Standish, ME",
      rating: 5,
      text: "Lost my passport 5 days before a cruise from Portland. Fast Passport Center walked me through the DS-64 form and had my replacement ready in 2 days. Incredible service.",
      service: "Lost Passport",
    },
    {
      name: "James T.",
      location: "Naples, ME",
      rating: 5,
      text: "Child passport for my twin boys. The team explained every parental consent requirement clearly and helped us find an acceptance clerk appointment. Passports arrived in 5 days.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "windham-1",
      name: "Windham Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "765 Roosevelt Trail",
      city: "Windham",
      state: "ME",
      zip: "04062",
      phone: "(207) 892-2821",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.5 miles from North Windham",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Limited passport acceptance hours. Call ahead to confirm availability and book appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "windham-2",
      name: "Westbrook Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "104 Larrabee Rd",
      city: "Westbrook",
      state: "ME",
      zip: "04092",
      phone: "(207) 856-3221",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "8 miles from Windham",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Larger facility with more appointment slots. Popular for Windham and Gorham residents.",
      icon: "ri-mail-line",
    },
    {
      id: "windham-3",
      name: "Gorham Town Office",
      type: "Town Office Passport Acceptance",
      address: "75 South St",
      city: "Gorham",
      state: "ME",
      zip: "04038",
      phone: "(207) 839-5037",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "10 miles from Windham",
      website: "https://www.gorham-me.org/",
      websiteLabel: "Gorham Town Office",
      notes: "Convenient for Gorham, Buxton, and Hollis residents. Appointment preferred.",
      icon: "ri-government-line",
    },
    {
      id: "windham-4",
      name: "Raymond Town Office",
      type: "Town Office Passport Acceptance",
      address: "1,000 Roosevelt Trail",
      city: "Raymond",
      state: "ME",
      zip: "04071",
      phone: "(207) 655-4742",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "12 miles from Windham",
      website: "https://www.raymondmaine.org/",
      websiteLabel: "Raymond Town Office",
      notes: "Good option for Raymond and Naples residents. Call ahead to schedule.",
      icon: "ri-government-line",
    },
    {
      id: "windham-5",
      name: "Standish Town Office",
      type: "Town Office Passport Acceptance",
      address: "175 Northeast Rd",
      city: "Standish",
      state: "ME",
      zip: "04084",
      phone: "(207) 642-3461",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "15 miles from Windham",
      website: "https://www.standish.org/",
      websiteLabel: "Standish Town Office",
      notes: "Rural option for Standish and Sebago residents.",
      icon: "ri-government-line",
    },
    {
      id: "windham-6",
      name: "Portland Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "125 Forest Ave",
      city: "Portland",
      state: "ME",
      zip: "04101",
      phone: "(207) 871-8381",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "18 miles from Windham",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Largest facility with the most appointment availability. Best backup option.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — drive to Boston", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Maine photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Windham acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Windham applicants show up with incorrect checks and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Boston regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Windham families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Windham travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Windham or Portland." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Windham address — trackable every step of the way." },
  ],
  faqs: [
    {
      q: "How fast can I get an emergency passport in Windham, Maine?",
      a: "Fast Passport Center offers emergency passport processing in Windham in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, bypassing standard mail delays. This is the fastest reliable option for Windham travelers with urgent international flights.",
    },
    {
      q: "Can I get a same-day passport in Windham, Maine?",
      a: "Same-day passports are only available at the Boston Regional Passport Agency for documented life-or-death emergencies with proof of travel within 72 hours. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option available to Windham residents.",
    },
    {
      q: "Where can I get a fast passport renewal in Windham, Maine?",
      a: "Fast Passport Center offers fast passport renewal in Windham with no office visit required. We serve all Windham neighborhoods and the Sebago Lakes region. Simply complete your application online, ship your documents using our prepaid overnight label, and our couriers handle the rest.",
    },
    {
      q: "How close is Windham to the Boston Passport Agency?",
      a: "Windham is approximately 120 miles from the Boston Passport Agency — about a 2-hour drive. With Fast Passport Center, you avoid that trip entirely. We courier your documents directly to State Department facilities, saving you time and stress.",
    },
    {
      q: "What acceptance facilities are near Windham, Maine?",
      a: "Options near Windham include the Windham Post Office (04062), Westbrook Post Office (04092), Gorham Town Office (04038), and Raymond Town Office (04071). The Portland Main Post Office (04101) is just 18 miles away with the most appointment slots. We help you find the most convenient location.",
    },
    {
      q: "Do I need to visit the Boston Passport Agency?",
      a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change.",
    },
    {
      q: "What if I live in Sebago, Naples, or Raymond?",
      a: "We serve all of the Sebago Lakes area including Windham, Sebago, Naples, Raymond, Standish, and Buxton. Our overnight shipping labels work from any UPS location, and we can also arrange pickup service. Your rural location doesn't affect processing speed.",
    },
    {
      q: "How much does expedited passport service cost in Windham?",
      a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed. Contact us for a personalized quote based on your timeline and needs.",
    },
    {
      q: "What documents do I need for a first-time passport in Windham?",
      a: "You'll need proof of citizenship (birth certificate or naturalization certificate), government-issued photo ID (driver's license or REAL ID), two passport photos, and payment. We provide a complete checklist and review your documents before you visit the acceptance clerk.",
    },
    {
      q: "Can you help with a child's passport in Windham?",
      a: "Yes. Child passports require both parents (or notarized consent from the absent parent), the child's birth certificate, and both parents' IDs. We walk Windham families through the entire process and help schedule acceptance clerk appointments.",
    },
    {
      q: "Is there a UPS Store near Windham for shipping documents?",
      a: "Yes, there's a UPS Store in Windham at 795 Roosevelt Trail. We provide a prepaid overnight label — just drop your package at any UPS location or schedule a pickup. The Portland UPS Store on Forest Ave is another nearby option.",
    },
    {
      q: "Can I get passport photos taken in Windham?",
      a: "The Walgreens on Roosevelt Trail in Windham offers passport photo services. The CVS Pharmacy on Main Street in Westbrook and the Rite Aid in Gorham also take passport photos. We recommend reviewing photos with us before your acceptance clerk visit.",
    },
  ],
  photoLocations: [
    { name: "Walgreens — Windham", address: "781 Roosevelt Trail, Windham, ME 04062", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — Westbrook", address: "65 Main St, Westbrook, ME 04092", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Rite Aid — Gorham", address: "45 Main St, Gorham, ME 04038", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Portland", address: "700 Forest Ave, Portland, ME 04103", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — Portland", address: "700 Forest Ave, Portland, ME 04103", hours: "Mon–Sun: 8AM–10PM" },
    { name: "UPS Store — Windham", address: "795 Roosevelt Trail, Windham, ME 04062", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "Walmart Photo Center — Portland", address: "700 Warren Ave, Portland, ME 04103", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walgreens — Scarborough", address: "600 US Route 1, Scarborough, ME 04074", hours: "Mon–Sun: 7AM–11PM" },
  ],
  dmvLocations: [
    {
      name: "BMV — Portland",
      address: "36 Pine St, Portland, ME 04102",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Full-service BMV. Online appointment booking available. 18 miles from Windham.",
      featured: true,
    },
    {
      name: "BMV — Windham",
      address: "800 Roosevelt Trail, Windham, ME 04062",
      hours: "Mon–Fri: 9AM–4PM",
      note: "Limited services only. Full transactions require Portland location.",
      featured: false,
    },
    {
      name: "BMV — Gorham",
      address: "75 South St, Gorham, ME 04038",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Second nearest full-service BMV. 10 miles from Windham.",
      featured: false,
    },
    {
      name: "BMV — Scarborough",
      address: "600 US Route 1, Scarborough, ME 04074",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Cumberland County option. About 20 miles from Windham.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "PWM",
      name: "Portland International Jetport",
      distance: "18 miles from Windham (25 min)",
      address: "1001 Westbrook St, Portland, ME 04102",
      note: "Maine's busiest airport with direct flights to major U.S. hubs, Florida, and Canada. The closest and most convenient international departure point for Windham travelers.",
      flightUrl: "https://www.portlandjetport.org/",
      flightLabel: "PWM Flight Info",
      featured: true,
    },
    {
      code: "BGR",
      name: "Bangor International Airport",
      distance: "110 miles from Windham (2 hours)",
      address: "2870 Godfrey Blvd, Bangor, ME 04401",
      note: "Maine's second busiest airport. Good alternative for northern Maine connections.",
      flightUrl: "https://www.flybangor.com/",
      flightLabel: "Bangor Airport",
      featured: false,
    },
    {
      code: "BOS",
      name: "Logan International Airport",
      distance: "120 miles from Windham (2 hours)",
      address: "1 Harborside Dr, Boston, MA 02128",
      note: "Major international hub with direct flights to Europe, Asia, and Latin America. Many southern Maine travelers connect through Boston for international travel.",
      flightUrl: "https://www.massport.com/logan-airport",
      flightLabel: "Logan Airport",
      featured: false,
    },
  ],
};